module.exports = __webpack_public_path__ + "static/media/7C.768d16ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/7C.svg
// module id = 73
// module chunks = 0